/* eslint-disable max-len */
import { OV_EMS_CDN } from '../../config/theme';
var PUBLISHED = 'PUBLISHED';
export var HERO_DESKTOP = {
  image: {
    alt: 'A group of people walking in a field wearing Outdoor Voices clothing',
    height: 1350,
    sizes: [320, 600, 1200, 1420],
    src: "".concat(OV_EMS_CDN, "media/banners/220711_Shot_15_3912_1_2dhNeXy.jpg"),
    width: 2400
  },
  products: {
    edges: [{
      node: {
        id: 'product-1',
        xPosition: 0.215,
        yPosition: 0.27,
        faceout: null,
        product: {
          absoluteUrl: '/products/w-recfleece-snap-jacket?variant=39992884920398',
          status: PUBLISHED,
          title: 'RecFleece Snap Jacket'
        }
      }
    }, {
      node: {
        id: 'product-2',
        xPosition: 0.24,
        yPosition: 0.533154296875,
        faceout: null,
        product: {
          absoluteUrl: '/products/w-relay-pant?variant=39988189790286',
          status: PUBLISHED,
          title: 'Relay Pant'
        }
      }
    }, {
      node: {
        id: 'product-3',
        xPosition: 0.36,
        yPosition: 0.24,
        faceout: null,
        product: {
          absoluteUrl: '/products/m-rugby-longsleeve?variant=39926737600590',
          status: PUBLISHED,
          title: 'Rugby Longsleeve'
        }
      }
    }, // {
    //   node: {
    //     id: 'product-4',
    //     xPosition: 0.36,
    //     yPosition: 0.41,
    //     faceout: null,
    //     product: {
    //       absoluteUrl:
    //         '/products/m-high-stride-5in-short-2?variant=39914400317518',
    //       status: PUBLISHED,
    //       title: 'High Stride 5" Short with Pockets',
    //     },
    //   },
    // },
    {
      node: {
        id: 'product-5',
        xPosition: 0.447,
        yPosition: 0.3,
        faceout: null,
        product: {
          absoluteUrl: '/products/w-the-exercise-dress?variant=39415801446478',
          status: PUBLISHED,
          title: 'The Exercise Dress'
        }
      }
    }, {
      node: {
        id: 'product-6',
        xPosition: 0.59,
        yPosition: 0.26,
        faceout: null,
        product: {
          absoluteUrl: '/products/m-megafleece-snap-up?variant=12572552790094',
          status: PUBLISHED,
          title: 'MegaFleece Snap Up'
        }
      }
    }, {
      node: {
        id: 'product-7',
        xPosition: 0.61,
        yPosition: 0.46,
        faceout: null,
        product: {
          absoluteUrl: '/products/m-rectrek-7in-short?variant=39668165083214',
          status: PUBLISHED,
          title: 'RecTrek 7" Short'
        }
      }
    }, {
      node: {
        id: 'product-8',
        xPosition: 0.77,
        yPosition: 0.25,
        faceout: null,
        product: {
          absoluteUrl: '/products/m-rugby-longsleeve?variant=39926736486478',
          status: PUBLISHED,
          title: 'Rugby Longsleeve'
        }
      }
    }, {
      node: {
        id: 'product-9',
        xPosition: 0.76,
        yPosition: 0.47,
        faceout: null,
        product: {
          absoluteUrl: '/products/w-relay-3in-short?variant=39897915031630',
          status: PUBLISHED,
          title: 'Relay 3" Short'
        }
      }
    }]
  }
};
export var HERO_MOBILE = {
  image: {
    alt: 'A group of people walking in a field wearing Outdoor Voices clothing',
    height: 1217,
    sizes: [320, 375],
    src: "".concat(OV_EMS_CDN, "media/banners/220711_Shot_15_3912_1_1_2ab92cE.jpg"),
    width: 1217
  },
  products: {
    edges: [{
      node: {
        id: 'product-m-1',
        xPosition: 0.112,
        yPosition: 0.4,
        product: {
          absoluteUrl: '/products/w-recfleece-snap-jacket?variant=39992884920398',
          status: PUBLISHED,
          title: 'RecFleece Snap Jacket'
        }
      }
    }, {
      node: {
        id: 'product-m-2',
        xPosition: 0.2,
        yPosition: 0.7,
        product: {
          absoluteUrl: '/products/w-relay-pant?variant=39988189790286',
          status: PUBLISHED,
          title: 'Relay Pant'
        }
      }
    }, {
      node: {
        id: 'product-m-3',
        xPosition: 0.4,
        yPosition: 0.27,
        product: {
          absoluteUrl: '/products/m-rugby-longsleeve?variant=39926737600590',
          status: PUBLISHED,
          title: 'Rugby Longsleeve'
        }
      }
    }, {
      node: {
        id: 'product-m-4',
        xPosition: 0.6,
        yPosition: 0.5,
        product: {
          absoluteUrl: '/products/w-the-exercise-dress?variant=39415801446478',
          status: PUBLISHED,
          title: 'The Exercise Dress'
        }
      }
    }, {
      node: {
        id: 'product-m-5',
        xPosition: 0.8,
        yPosition: 0.16,
        product: {
          absoluteUrl: '/products/m-megafleece-snap-up?variant=12572552790094',
          status: PUBLISHED,
          title: 'MegaFleece Snap Up'
        }
      }
    }]
  }
};